import React from 'react';
export function ProblemSection() {
  return <section className="relative bg-white py-12 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-122">
      {/* Decorative element */}
      <div className="absolute -right-20 top-10 w-64 h-64 border-[40px] border-neutral-bg rounded-full opacity-50 pointer-events-none" data-id="element-123"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-124">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-[#1A1A1A] mb-6 leading-tight" data-id="element-125">
          Si alguna vez intentaste tener plantas… dejame hacerte una pregunta
          honesta
        </h2>

        <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-126">
          ¿Te pasó que compraste una planta, la cuidaste lo mejor que pudiste… y
          aun así se murió? No porque no te importe. Sino porque nadie te enseñó
          cómo hacerlo de verdad.
        </p>

        <div className="relative inline-block" data-id="element-127">
          <div className="absolute inset-0 bg-earth-accent/5 transform -skew-x-12 rounded-2xl" data-id="element-128"></div>
          <div className="relative text-2xl sm:text-3xl font-black text-earth-accent p-6 sm:p-8 bg-white rounded-2xl border-l-8 border-earth-accent shadow-xl" data-id="element-129">
            👉 "Esto no es para mí."
          </div>
        </div>
      </div>
    </section>;
}